export const enum KeywordDataType {
    Null,
    LargeNumeric,
    AlphaNumeric,
    Currency,
    Date,
    Float,
    SmallNumeric,
    DateTime,
    AlphaNumericSingleTable,
    SpecificCurrency,
    AlphaNumericCSInsensitiveSearch,
    AlphaNumericSingleTableCSInsensitiveSearch
}



// WEBPACK FOOTER //
// ./src/app/shared/models/keyword-data-type.ts